import { render } from "./eye-closed.svg?vue&type=template&id=19288dfd"
const script = {}
script.render = render

export default script